import type { PaymentSelectionInput } from '../api/orders'

interface CheckoutPaymentMethod {
  id: string
  selection: PaymentSelectionInput
  label: string
  meta: string
  description: string
}

export const CHECKOUT_PAYMENT_METHODS: CheckoutPaymentMethod[] = [
  {
    id: 'qris',
    selection: { method: 'QR_CODE', channel: 'QRIS' },
    label: 'QRIS',
    meta: 'SCAN',
    description: 'Universal QR payment for banking and wallet apps.',
  },
  {
    id: 'bca',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'BCA' },
    label: 'BCA VA',
    meta: 'BANK',
    description: 'BCA virtual account transfer.',
  },
  {
    id: 'bni',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'BNI' },
    label: 'BNI VA',
    meta: 'BANK',
    description: 'BNI virtual account transfer.',
  },
  {
    id: 'bri',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'BRI' },
    label: 'BRI VA',
    meta: 'BANK',
    description: 'BRI virtual account transfer.',
  },
  {
    id: 'mandiri',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'MANDIRI' },
    label: 'Mandiri VA',
    meta: 'BANK',
    description: 'Mandiri bill payment transfer.',
  },
  {
    id: 'permata',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'PERMATA' },
    label: 'Permata VA',
    meta: 'BANK',
    description: 'Permata virtual account transfer.',
  },
  {
    id: 'cimb',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'CIMB' },
    label: 'CIMB VA',
    meta: 'BANK',
    description: 'CIMB virtual account transfer.',
  },
  {
    id: 'other-bank',
    selection: { method: 'VIRTUAL_ACCOUNT', channel: 'OTHER_BANK' },
    label: 'Other Bank',
    meta: 'BANK',
    description: 'Bank transfer using the supported shared VA route.',
  },
  {
    id: 'gopay',
    selection: { method: 'E_WALLET', channel: 'GOPAY' },
    label: 'GoPay',
    meta: 'WALLET',
    description: 'GoPay app payment.',
  },
  {
    id: 'shopeepay',
    selection: { method: 'E_WALLET', channel: 'SHOPEEPAY' },
    label: 'ShopeePay',
    meta: 'WALLET',
    description: 'ShopeePay app payment.',
  },
  {
    id: 'dana',
    selection: { method: 'E_WALLET', channel: 'DANA' },
    label: 'DANA',
    meta: 'WALLET',
    description: 'DANA wallet payment.',
  },
]
